import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";
import { MarketingSetupServicePage } from "../components/marketing/MarketingSetupServicePage";

export const Route = createFileRoute("/services/maito-setup")({
  head: () => marketingHead("/services/maito-setup"),
  component: MarketingSetupServicePage,
});
